@if (iframeLoaded) {
  @if (sandbox == true && !allow) {
    <iframe #iframe (load)="load(iframe)" width="100%" height="100%" frameBorder="0" [src]="urlSafe"
    sandbox="allow-scripts allow-same-origin allow-popups"></iframe>
  }
  @if (sandbox == false && !allow) {
    <iframe #iframe (load)="load(iframe)" width="100%" height="100%" frameBorder="0" [src]="urlSafe"
    ></iframe>
  }
  @if (sandbox == true && allow) {
    <iframe #iframe (load)="load(iframe)" width="100%" height="100%" frameBorder="0" [src]="urlSafe"
      allow="microphone; clipboard-read; clipboard-write"
    sandbox="allow-scripts allow-same-origin allow-popups"></iframe>
  }
  @if (sandbox == false && allow) {
    <iframe #iframe (load)="load(iframe)" width="100%" height="100%" frameBorder="0" [src]="urlSafe"
    allow="microphone; clipboard-read; clipboard-write"></iframe>
  }
}
<nts-loader [isVisible]="!iframeLoaded"></nts-loader>